import {
  IFeatureModalData,
  IControlButtonTexts
} from 'module/productfeaturemodal/productfeaturemodal.types'

export const preMigrationFeatureModalLink =
  'https://challenges.aflmint.com.au/articles/afl-mint-base-blockchain-101'

export const preMigrationFeatureModalData: IFeatureModalData[] = [
  {
    image: '/assets/Image/migrations-1-popup.jpg',
    tag: 'AFL MINT UPDATE',
    heading: 'We’re preparing for the move to Base',
    body: `AFL Mint will soon be migrating from Flow blockchain to Base. To move every collection across safely, we first need to take a snapshot — a complete record of what each wallet holds at a single point in time. That snapshot is what we use to rebuild your collection on Base.`
  },
  {
    image: '/assets/Image/migrations-2-popup.jpg',
    tag: 'AFL MINT UPDATE',
    heading: 'Why some pages are paused',
    body: (
      <div>
        Buying, opening and trading all change what sits in your wallet, so
        while the snapshot is being taken we have temporarily paused:
        <ul className="mt-2 ml-5 list-disc">
          <li>The Marketplace Buying/Selling</li>
          <li>Buying packs</li>
          <li>Opening packs</li>
          <li>Revealing Genesis Balls</li>
          <li>Any Burning of moments</li>
        </ul>
        <p className="mt-2">
          If these stay, a Moment or Genesis Ball could move between wallets
          during or after the snapshot was captured and end up in the wrong
          place on Base. Pausing them keeps everyone&apos;s holdings stable and
          accurate.
        </p>
      </div>
    )
  },
  {
    image: '/assets/Image/migrations-popup.jpg',
    tag: 'AFL MINT UPDATE',
    heading: 'Your collection is safe',
    body: (
      <div>
        Nothing is being taken away. We are creating a 1:1 version of your
        wallet on Base — every Moment you own on Flow will be recreated for you
        on Base, tied to your AFL iD and email address. We only need your
        holdings to stay unchanged for a few days while that work is completed,
        after which the paused pages will return.{' '}
      </div>
    )
  }
]

export const preMigrationControlButtonTexts: IControlButtonTexts = {
  prev: 'Back',
  next: 'Next',
  end: 'Got it'
}
